import { render, staticRenderFns } from "./ProdutosMesa.vue?vue&type=template&id=6adc3c22&scoped=true&"
import script from "./ProdutosMesa.vue?vue&type=script&lang=js&"
export * from "./ProdutosMesa.vue?vue&type=script&lang=js&"
import style0 from "./ProdutosMesa.vue?vue&type=style&index=0&id=6adc3c22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adc3c22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
